// ── Action Types ──────────────────────────────────────────
export const GET_CAREER_PATH_REQUEST = 'GET_CAREER_PATH_REQUEST';
export const GET_CAREER_PATH_SUCCESS = 'GET_CAREER_PATH_SUCCESS';
export const GET_CAREER_PATH_FAIL    = 'GET_CAREER_PATH_FAIL';

export const GET_ALL_CAREER_PATHS_REQUEST = 'GET_ALL_CAREER_PATHS_REQUEST';
export const GET_ALL_CAREER_PATHS_SUCCESS = 'GET_ALL_CAREER_PATHS_SUCCESS';
export const GET_ALL_CAREER_PATHS_FAIL    = 'GET_ALL_CAREER_PATHS_FAIL';

export const GET_ACTIVE_CAREER_PATHS_REQUEST = 'GET_ACTIVE_CAREER_PATHS_REQUEST';
export const GET_ACTIVE_CAREER_PATHS_SUCCESS = 'GET_ACTIVE_CAREER_PATHS_SUCCESS';
export const GET_ACTIVE_CAREER_PATHS_FAIL    = 'GET_ACTIVE_CAREER_PATHS_FAIL';

export const CREATE_CAREER_PATH_REQUEST = 'CREATE_CAREER_PATH_REQUEST';
export const CREATE_CAREER_PATH_SUCCESS = 'CREATE_CAREER_PATH_SUCCESS';
export const CREATE_CAREER_PATH_FAIL    = 'CREATE_CAREER_PATH_FAIL';

export const UPDATE_CAREER_PATH_REQUEST = 'UPDATE_CAREER_PATH_REQUEST';
export const UPDATE_CAREER_PATH_SUCCESS = 'UPDATE_CAREER_PATH_SUCCESS';
export const UPDATE_CAREER_PATH_FAIL    = 'UPDATE_CAREER_PATH_FAIL';

export const DELETE_CAREER_PATH_REQUEST = 'DELETE_CAREER_PATH_REQUEST';
export const DELETE_CAREER_PATH_SUCCESS = 'DELETE_CAREER_PATH_SUCCESS';
export const DELETE_CAREER_PATH_FAIL    = 'DELETE_CAREER_PATH_FAIL';

export const SET_CAREER_PATH_LOADING = 'SET_CAREER_PATH_LOADING';

// ── Action Creators ───────────────────────────────────────
export const getCareerPathRequest = (careerPathId) => ({
    type: GET_CAREER_PATH_REQUEST,
    payload: { careerPathId }
});
export const getCareerPathSuccess = (careerPath) => ({
    type: GET_CAREER_PATH_SUCCESS,
    payload: careerPath
});
export const getCareerPathFail = (error) => ({
    type: GET_CAREER_PATH_FAIL,
    error
});

export const getAllCareerPathsRequest = () => ({
    type: GET_ALL_CAREER_PATHS_REQUEST
});
export const getAllCareerPathsSuccess = (careerPaths) => ({
    type: GET_ALL_CAREER_PATHS_SUCCESS,
    payload: careerPaths
});
export const getAllCareerPathsFail = (error) => ({
    type: GET_ALL_CAREER_PATHS_FAIL,
    error
});

export const getActiveCareerPathsRequest = () => ({
    type: GET_ACTIVE_CAREER_PATHS_REQUEST
});
export const getActiveCareerPathsSuccess = (careerPaths) => ({
    type: GET_ACTIVE_CAREER_PATHS_SUCCESS,
    payload: careerPaths
});
export const getActiveCareerPathsFail = (error) => ({
    type: GET_ACTIVE_CAREER_PATHS_FAIL,
    error
});

export const createCareerPathRequest = (careerPathData, history) => ({
    type: CREATE_CAREER_PATH_REQUEST,
    payload: careerPathData,
    history
});
export const createCareerPathSuccess = (careerPath) => ({
    type: CREATE_CAREER_PATH_SUCCESS,
    payload: careerPath
});
export const createCareerPathFail = (error) => ({
    type: CREATE_CAREER_PATH_FAIL,
    error
});

export const updateCareerPathRequest = (careerPathId, careerPathData) => ({
    type: UPDATE_CAREER_PATH_REQUEST,
    payload: { careerPathId, careerPathData }
});
export const updateCareerPathSuccess = (careerPath) => ({
    type: UPDATE_CAREER_PATH_SUCCESS,
    payload: careerPath
});
export const updateCareerPathFail = (error) => ({
    type: UPDATE_CAREER_PATH_FAIL,
    error
});

export const deleteCareerPathRequest = (careerPathId) => ({
    type: DELETE_CAREER_PATH_REQUEST,
    payload: { careerPathId }
});
export const deleteCareerPathSuccess = (careerPathId) => ({
    type: DELETE_CAREER_PATH_SUCCESS,
    payload: { careerPathId }
});
export const deleteCareerPathFail = (error) => ({
    type: DELETE_CAREER_PATH_FAIL,
    error
});

export const setCareerPathLoading = (loading) => ({
    type: SET_CAREER_PATH_LOADING,
    payload: loading
});